import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Row, Col } from 'reactstrap'
import { MessageDetailContent } from './detail-content'
import RichTextWithAttachment from '@/components/messages/richtext-with-attachment'
import MessageEditButtons from '@/components/messages/edit-buttons'
import { actionCreators } from '@/store/Messages'
import { ValidationBoundary } from '@/components/validation'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useDispatch } from '@/hooks/dispatch'

const MessageReply = function MessageReply ({ backUrl, ...props }) {
  const { message, attachments, replyMessage, replyAttachments, replyRetrieved } = useSelector((state) => {
    return {
      message: state.messages.message,
      attachments: state.messages.attachments,
      replyMessage: state.messages.replyMessage,
      replyAttachments: state.messages.replyAttachments,
      retrieved: state.messages.retrieved,
      replyRetrieved: state.messages.replyRetrieved }
  })
  const [getMessage, updateDto, updateAttachments] = useDispatch(
    [actionCreators.getMessage, actionCreators.updateDto, actionCreators.updateAttachments])

  useEffect(() => {
    const { id, replyId } = props.match.params

    if (replyId) getMessage(replyId, true)
    else getMessage(id)
  }, [getMessage, props.match.params])

  const { replyId } = props.match.params

  return (
    <Main path={{ text: 'Messages.Reply' }}>
      <MainTop>
        <MainTopTitle backUrl={backUrl}>
          <Resx name='Messages.Reply' />
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <Row>
          <Col>
            <ValidationBoundary>
              <WhiteBox>
                {!message || !message.id
                  ? <LoadingIndicator />
                  : <MessageDetailContent message={message} attachments={attachments} />
                }
              </WhiteBox>
              <WhiteBox>
                {replyId && !replyRetrieved
                  ? <LoadingIndicator />
                  : <React.Fragment>
                    <RichTextWithAttachment
                      replyMessage={replyMessage}
                      replyAttachments={replyAttachments}
                      attachments={attachments}
                      updateAttachments={updateAttachments}
                      updateDto={updateDto}
                      isReply />
                    <MessageEditButtons message={replyMessage} isReply />
                  </React.Fragment>
                }
              </WhiteBox>
            </ValidationBoundary>
          </Col>
        </Row>
      </MainBody>
    </Main>
  )
}

export { MessageReply }



// WEBPACK FOOTER //
// ./src/components/messages/reply.js